import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./recommendations_first_load_visibility.js";
//#region src/recommendations_first_load_visibility_helper.ts
var recommendations_first_load_visibility_helper_exports = /* @__PURE__ */ __exportAll({
	name: () => name,
	recommendationsFirstLoadVisibilityEnum: () => recommendationsFirstLoadVisibilityEnum,
	recommendationsFirstLoadVisibilityValues: () => recommendationsFirstLoadVisibilityValues,
	recommendationsInMenuVisibilityEnum: () => recommendationsInMenuVisibilityEnum,
	recommendationsInMenuVisibilityValues: () => recommendationsInMenuVisibilityValues
});
const recommendationsFirstLoadVisibilityEnum = {
	Hidden: "hidden",
	OrderHistory: "order-history",
	PredictionsAndOrderHistory: "predictions-and-order-history"
};
const recommendationsInMenuVisibilityEnum = {
	Hidden: "hidden",
	OrderHistory: "order-history",
	Predictions: "predictions",
	PredictionsAndOrderHistory: "predictions-and-order-history"
};
const recommendationsFirstLoadVisibilityValues = Object.values(recommendationsFirstLoadVisibilityEnum);
const recommendationsInMenuVisibilityValues = Object.values(recommendationsInMenuVisibilityEnum);
function name(visibility) {
	switch (visibility) {
		case "hidden": return "Hidden";
		case "order-history": return "Order History/Favorites";
		case "predictions": return "Predictions";
		case "predictions-and-order-history": return "Predictions + Order History/Favorites";
	}
}
//#endregion
export { name, recommendationsFirstLoadVisibilityEnum, recommendationsFirstLoadVisibilityValues, recommendationsInMenuVisibilityEnum, recommendationsInMenuVisibilityValues, recommendations_first_load_visibility_helper_exports };

//# sourceMappingURL=recommendations_first_load_visibility_helper.js.map